<template>
<div>
  <div v-if="edit">
    <saved-search-edit :saved-search="edit" @save="save" @cancel="edit = null"></saved-search-edit>
  </div>

  <div v-else>
    <div class="row p-t-lg">
      <template v-for="item in items">
        <div class="col-24 col-md-12 col-lg-8" :key="item.uuid">
          <saved-search :item="item" :fields-config="fieldsConfig" :category-list="categoryList" @remove="remove" @edit="openEdit"></saved-search>
        </div>
      </template>
    </div>
  </div>

  <confirm v-model="confirm" title="Suchprofil löschen">
    <template>
      {{ $t("Möchten Sie Ihr Suchprofil wirklich löschen?") }}
    </template>
  </confirm>
</div>
</template>

<script>
import SavedSearch from "./SavedSearch";
import SavedSearchEdit from "./SavedSearchEdit";
import Confirm from "./Confirm";

export default {
  name: "SavedSearchList",

  components: {
    SavedSearch,
    SavedSearchEdit,
    Confirm
  },

  props: [
    "fieldsConfig",
    "categoryList",
    "items"
  ],

  data() {
    return {
      confirm: false,
      edit: null
    }
  },

  created() {
    this.$store.dispatch("appData", {"title": this.$t("Suchanfragen")});
  },

  methods: {
    remove(ss) {
      this.confirm = {
        data: ss,
        ok: () => {
          this.$emit("remove", ss);
        }
      };
    },

    save(inquiry) {
      this.$emit("save", inquiry);
      this.edit = null;
    },

    openEdit(ss) {
      this.edit = ss;
    }
  }
};
</script>
